//export const MQTT_SERVICE = 'wss://unione-tech.com:9002/mqtt' 
//export const MQTT_SERVICE = 'wss://zenglei.icu/mqtt'  //测试
//export const MQTT_SERVICE = 'wss://unione-tech.com:442/mqtt' //测试
export const MQTT_SERVICE = 'wss://unione-robot.com/mqtt' //正式
export const MQTT_USERNAME = 'dsadsad'











// WEBPACK FOOTER //
// ./src/components/robot/sysconstant.js